import './style.scss'

import getPathFromUrl from 'util/getPathFromUrl'
import Title from 'components/Title'

export default {
  name: 'Teaser',
  props: {
    'title': {
      type: String
    },
    'content': {
      type: String
    },
    'pageLink': {
      type: String
    },
    'image': {
      type: Object
    }
  },
  computed: {
    internalLinkPath () {
      return this.pageLink ? getPathFromUrl(this.pageLink) : null
    }
  },
  render (h) {
    const { title, content, internalLinkPath, image } = this
    return (
      image ? renderImageTeaser(h, title, internalLinkPath, image) : renderTextTeaser(h, title, content, internalLinkPath)
    )
  }
}

function renderImageTeaser (h, title, internalLinkPath, image) {
  return <div class='Teaser Teaser--image'>
    <router-link class='Teaser__content' to={internalLinkPath}>
      <Title class='Teaser__title' level={3} id={title}>{title}</Title>
      <div class='Teaser__image' style={image ? `background-image: url('${image.sizes.medium_large}')` : ''} />
      <img class='Teaser__printImage' src={image.sizes.medium_large} />
    </router-link>
    <Title class='Teaser__fallback-title' level={3} id={title}>{title}</Title>
  </div>
}

function renderTextTeaser (h, title, content, internalLinkPath) {
  return <div class='Teaser Teaser--text'>
    { internalLinkPath
      ? <router-link class='Teaser__content' to={internalLinkPath}>
        <Title class='Teaser__title' level={3} id={title}>{title}</Title>
        <p class='Teaser__text'>{content}</p>
      </router-link>
      : <div class='Teaser__content'>
        <Title class='Teaser__title' level={3} id={title}>{title}</Title>
        <p class='Teaser__text'>{content}</p>
      </div>
    }
  </div>
}



// WEBPACK FOOTER //
// ./client/components/Teaser/index.js